export default "__VITE_ASSET__d977fc78__"